// 포폴 총 자산
export function PortfolioTotalPrice(portfolio: any, locale: string | undefined) {
    // const router = useRouter();
    if (portfolio) {
        return locale === "ko"
            ? portfolio.totalPortfolioPriceKr
                ? portfolio.totalPortfolioPriceKr.toLocaleString(
                    "en-us",
                    {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                    }
                ) + " 원"
                : "-"
            : locale === "en"
                ? portfolio.totalPortfolioPriceUs
                    ? portfolio.totalPortfolioPriceUs.toLocaleString(
                        "en-us",
                        {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2,
                        }
                    ) + "＄"
                    : "-"
                : "-"
    }
    else {
        return "-";
    }
}

//포폴 총 수익
export function PortfolioTotalProfit(portfolio: any, locale: string | undefined) {
    // const router = useRouter();
    if (locale === "ko") {
        if (portfolio.totalPortfolioPriceKr && portfolio.totalUserPriceKr) {
            return Math.abs(
                portfolio.totalPortfolioPriceKr -
                portfolio.totalUserPriceKr
            ).toLocaleString("en-us", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }) + "원"
        }
        else {
            return "-"
        }
    }
    else if (locale === "en") {
        console.log((
            portfolio?.totalPortfolioPriceUs -
            portfolio?.totalUserPriceUs
        ).toLocaleString("en-us", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }))
        if (portfolio.totalPortfolioPriceUs && portfolio.totalUserPriceUs) {
            return Math.abs(
                portfolio.totalPortfolioPriceUs -
                portfolio.totalUserPriceUs
            ).toLocaleString("en-us", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            }) + "＄"
        }

        else {
            return ""
        }

    }

}

//포폴 총 수익 퍼센트
export function PortfolioTotalProfitPercent(portfolio: any) {

    return portfolio.totalChange ?
        "(" +
        Math.abs(portfolio.totalChange).toLocaleString("en-us", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }) +
        "%" +
        ")" : "(0%)";
}


//포폴 일간 수익
export function PortfolioDailyGain(portfolio: any, locale: string | undefined) {

    if (locale === "ko") {
        return Math.abs(portfolio.totalTodayProfit).toLocaleString("en-us", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }) + "원";
    }
    else {
        return Math.abs(portfolio.totalTodayProfitUs).toLocaleString("en-us", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }) + "＄";

    }

}

//포폴 일간 수익 퍼센트
export function PortfolioDailyGainPercent(portfolio: any) {

    return "(" +
        `${portfolio.totalTodayChangePer > 0 ? "+" : ""}` +
        (
            portfolio.totalTodayChangePer * 100
        ).toLocaleString("en-us", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }) +
        " %" +
        ")";
}


//보유 자산 보유 금액
export function AssetTotalPrice(asset: any, locale: string | undefined, isActive: boolean) {

    if (asset) {
        if (isActive) {
            if (locale === "ko") {
                return (asset.totalMarketKrPrice || String(asset.totalMarketKrPrice) === '0')
                    ? asset.totalMarketKrPrice.toLocaleString("en-us", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                    }) + "원"
                    : "-"
            }
            else {
                return asset.totalMarketUsPrice
                    ? asset.totalMarketUsPrice.toLocaleString("en-us", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                    }) + `$`
                    : "-"
            }
        }
        else {
            return asset.totalMarketPrice
                ? asset.totalMarketPrice.toLocaleString("en-us", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                }) + `${asset?.curr}`
                : "-"
        }
    }
    else {
        return "-";
    }
}

//보유 자산 총 수익
export function AssetTotalProfit(asset: any, locale: string | undefined, isActive: boolean) {
    if (isActive) {
        if (locale === "ko") {
            if (asset.totalMarketKrPrice && asset.userTotalKr) {
                return Math.abs(
                    asset.totalMarketKrPrice -
                    asset.userTotalKr
                ).toLocaleString("en-us", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                }) + "원";
            }
            else {
                return "-"
            }
        }
        else {
            if (asset.totalMarketUsPrice && asset.userTotalUs) {
                return Math.abs(
                    asset.totalMarketUsPrice -
                    asset.userTotalUs
                ).toLocaleString("en-us", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                }) + "$";
            }
            else {
                return "-"
            }
        }
    }

    else {
        if (asset.totalMarketPrice && asset.userTotal) {
            return Math.abs(
                asset.totalMarketPrice -
                asset.userTotal
            ).toLocaleString("en-us", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            }) + `${asset?.curr}`
        }
        else {
            return "-"
        }
    }

}

//보유 자산 총 수익 퍼센트
export function AssetTotalProfitPercent(asset: any) {

    return (asset.userChange || (String(asset.userChange) === '0')) &&
        `(` + Math.abs(asset.userChange).toLocaleString("en-us", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }) +
        "%" +
        ")";
}

//보유 자산 현재가
export function AssetCurrentPrice(asset: any, locale: string | undefined, isActive: boolean) {

    if (isActive) {
        if (locale === "ko") {
            return asset.marketPriceKr
                ? asset.marketPriceKr.toLocaleString("en-us", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                }) + "원"
                : asset?.marketPrice?.toLocaleString("en-us", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                }) + "원"
        }
        else {
            return asset.marketPriceUs
                ? asset.marketPriceUs.toLocaleString("en-us", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                }) + "$"
                : "-"
        }
    }
    else {
        return asset.marketPrice
            ? asset.marketPrice.toLocaleString("en-us", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            }) + `${asset?.curr}`
            : "-"
    }

}

//보유 자산 일간 수익 - 수량 적용 X
export function AssetDailyGain(asset: any, locale: string | undefined, isActive: boolean,) {

    if (isActive) {
        if (locale === "ko") {
            return Math.abs(asset.todayProfit).toLocaleString("en-us", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }) + "원";
        }
        else {
            return Math.abs(asset.todayProfitUs).toLocaleString("en-us", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            }) + "$";
        }
    }
    else {
        return asset?.todayProfitBasic ? Math.abs(asset.todayProfitBasic).toLocaleString("en-us", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }) + `${asset?.curr}` : Math.abs(asset?.todayProfit).toLocaleString("en-us", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }) + `${asset?.curr ? asset?.curr : ""}`
    }
}

export function AssetDailyGainWithWeight(asset: any, locale: string | undefined, isActive: boolean,) {
    if (isActive) {
        if (locale === "ko") {
            return Math.abs(asset.todayProfitWithQuantity).toLocaleString("en-us", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }) + "원";
        }
        else {
            return Math.abs(asset.todayProfitUsWithQuantity).toLocaleString("en-us", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            }) + "$";
        }
    }
    else {
        return asset?.todayProfitBasicWithQuantity ? Math.abs(asset.todayProfitBasicWithQuantity).toLocaleString("en-us", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }) + `${asset?.curr}` : Math.abs(asset?.todayProfitWithQuantity).toLocaleString("en-us", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }) + `${asset?.curr ? asset?.curr : ""}`
    }
}

//보유 자산 일간 수익 퍼센트
export function AssetDailyGainPercent(asset: any) {

    return "(" +
        `` +
        (
            Math.abs(asset.todayChangePercentage) * 100
        ).toLocaleString("en-us", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }) +
        "%" +
        ")";
}

//보유 자산 평균 단가
export function AssetAveragePrice(asset: any, locale: string | undefined, isActive?: boolean) {

    if (isActive) {
        if (locale === "ko") {
            return asset.priceKr
                ? asset.priceKr.toLocaleString("en-us", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                }) + " 원"
                : asset?.price?.toLocaleString("en-us", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                }) + " 원"
        }
        else {
            return asset.priceUs
                ? asset.priceUs.toLocaleString("en-us", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                }) + " $"
                : "-"
        }
    }
    else {
        return asset.priceOrigin
            ? asset.priceOrigin.toLocaleString("en-us", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            }) + `${asset?.curr}`
            : asset.price
                ? asset.price.toLocaleString("en-us", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                }) : "-"
    }
}

//보유 자산 수량
export function AssetQuantity(asset: any) {
    return asset.quantity
        ? asset.quantity.toLocaleString("en-us", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        })
        : "-";
}

//보유 자산 원금
export function AssetPrincipal(asset: any, locale: string | undefined, isActive?: boolean,) {


    if (isActive) {
        if (locale === "ko") {
            return (asset.priceKr * asset.quantity)
                ? (asset.priceKr * asset.quantity).toLocaleString("en-us", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                }) + " 원"
                : "-"
        }
        else {
            return (asset.priceUs * asset.quantity)
                ? (asset.priceUs * asset.quantity).toLocaleString("en-us", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                }) + " $"
                : "-"
        }
    }
    else {
        return asset.priceOrigin && asset.quantity ? (asset.priceOrigin * asset.quantity).toLocaleString("en-us", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }) + `${asset?.curr}` : (asset.price * asset.quantity).toLocaleString("en-us", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }) + `${asset?.curr ? asset?.curr : ""}`

    }
}

//보유 자산 최대 하락시
export function AssetMaxLoss(asset: any, locale: string | undefined, detailData?: any, isActive?: boolean) {
    if (isActive) {
        if (locale === 'ko') {
            return asset &&
                asset?.totalMarketKrPrice &&
                (
                    (1 - detailData.EXP_CVaRNTS_95 / 100) *
                    asset.totalMarketKrPrice
                ).toLocaleString("en-us", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                }) + `원`
        }
        else {
            return asset &&
                asset?.totalMarketUsPrice &&
                (
                    (1 - detailData.EXP_CVaRNTS_95 / 100) *
                    asset.totalMarketUsPrice
                ).toLocaleString("en-us", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                }) + `$`
        }
    }
    else {
        return asset &&
            asset?.totalMarketPrice &&
            (
                (1 - detailData.EXP_CVaRNTS_95 / 100) *
                asset.totalMarketPrice
            ).toLocaleString("en-us", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            }) + `${detailData.CURR || detailData?.curr}`
    }
}

//보유 자산 최대 상승시
export function AssetMaxGain(asset: any, locale: string | undefined, detailData: any, isActive?: boolean,) {
    if (isActive) {
        if (locale === 'ko') {
            return asset &&
                asset?.totalMarketKrPrice &&
                (
                    (1 + detailData.EXP_CVaRET_95 / 100) *
                    asset.totalMarketKrPrice
                ).toLocaleString("en-us", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                }) + `원`
        }
        else {
            return asset &&
                asset?.totalMarketUsPrice &&
                (
                    (1 + detailData.EXP_CVaRET_95 / 100) *
                    asset.totalMarketUsPrice
                ).toLocaleString("en-us", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                }) + `$`
        }
    }
    else {
        return asset &&
            asset?.totalMarketPrice &&
            (
                (1 + detailData.EXP_CVaRET_95 / 100) *
                asset.totalMarketPrice
            ).toLocaleString("en-us", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            }) + `${detailData.CURR || detailData?.curr}`
    }
}

//실제 등락률 추가 - 오늘자 리스크는 나와있고 오늘자 등락률 데이터가 있는 경우

{
    /**
    1. 크립토가 포함된 포폴의 경우
     - 항상 추가되는 오늘의 실제 등락률

    2. 크립토가 포함된 포폴이 아닌 경우
      2-1 : 한국 자산이 포함된경우 
             >> 한국 장 시간동안 && targetDate 가 오늘 날짜와 같은 경우 : 오늘의 실제 등락률 추가
      2-2 : 미국만 있는 경우 : 추가하지 않음

    */
}

export function portfolioTodayChangesHandler({ userPort, targetDate, activeTimeHandler, inactiveTimeHanlder, prevActiveHanlder, yesterdayIsHoliday = false, cryptoCalcurating }: { userPort: any, targetDate: any, activeTimeHandler?: any, inactiveTimeHanlder?: any, prevActiveHanlder?: any, yesterdayIsHoliday?: boolean, cryptoCalcurating?: any }) {



    {/**
    activeTimeHandler : 마지막 날짜에 대한 등락률을 추가 핸들러
    inactiveTimeHanlder : 마지막 날짜에 대한 등락률을 제거하는 핸들러
    prevActiveHanlder : 마지막 날짜 -1 날짜에 대한 등락률을 덮어씌우는 핸들러
    */}

    const isCryptoInclude = userPort?.items.some(
        (item: any) => item.cat === "Crypto"
    );
    const isKoreaStockInclude = userPort?.items.some(
        (item: any) => item.loc === "Korea (South)"
    );
    const isAllCrypto = userPort?.items.every(
        (item: any) => item.cat === "Crypto"
    );

    const now = new Date();
    const utcOffset = now.getTimezoneOffset() * 60000; // 현재 로컬 시간대의 UTC 오프셋
    const utcTime = now.getTime() + utcOffset; // 현재 시간을 UTC로 변환
    const koreanOffset = 9 * 60 * 60000; // 한국은 UTC+9 시간대
    const koreaTime = new Date(utcTime + koreanOffset); // UTC 시간에 한국 시간 오프셋을 더함

    // const todayDateString = koreaTime.toISOString().split("T")[0];
    // console.log("todayDateString:", todayDateString);
    // console.log("target:", targetDate);

    const year = koreaTime.getFullYear();
    const month = String(koreaTime.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 1을 더해줌
    const day = String(koreaTime.getDate()).padStart(2, '0');

    const todayDateString = `${year}-${month}-${day}`;

    const hours = koreaTime.getHours();
    const minutes = koreaTime.getMinutes();
    // 크립토가 포함되지 않은 경우
    if (!isCryptoInclude) {
        // isKoreaStockInclude 일 때 targetDate 가 오늘 날짜와 같고, 한국 시간 기준 9시 5분 ~16시 사이 인 경우
        if (isKoreaStockInclude) {

            if (String(targetDate) == String(todayDateString)) {


                // 9시 5분 (9:05) ~ 16시 (16:00) 사이인지 확인

                if (
                    (hours > 9 || (hours === 9 && minutes >= 5)) &&
                    (hours < 16 || (hours === 16 && minutes < 10))
                ) {
                    // 오늘의 실제 등락률 추가
                    if (activeTimeHandler) {
                        activeTimeHandler()
                    }
                } else {
                    if (inactiveTimeHanlder) {
                        inactiveTimeHanlder()
                    }
                }
            } else {
                if (inactiveTimeHanlder) {
                    inactiveTimeHanlder()
                }
            }
        } else {
            if (inactiveTimeHanlder) {
                inactiveTimeHanlder()
            }
        }
    }
    else {
        // 크립토가 포함된 경우

        {/**    https://www.notion.so/2b3170e89895488c866ecd0c8f6d25a2 */ }



        // 크립토만 포함된 포폴인 경우
        if (isAllCrypto) {
            // 크립토 배치 돈 후 10시 20분 이후
            if (String(targetDate) == String(todayDateString)) {
                if (activeTimeHandler) {
                    activeTimeHandler()
                }
            }
            else {
                // 9시부터 10시 20분 사이
                if (hours >= 9 && hours < 10 || (hours === 10 && minutes <= 30)) {

                    if (cryptoCalcurating) {
                        cryptoCalcurating()
                    }
                    if (inactiveTimeHanlder) {
                        inactiveTimeHanlder()
                    }


                }
                else {
                    if (activeTimeHandler) {
                        activeTimeHandler()
                    }
                }
            }
            return;
        }


        //크립토만 포함된 포폴이 아닌 경우
        if (hours >= 0 && hours < 9) {
            // 한국 or 미국장 돌아서 이미 리스크 추가되어 있는 경우
            if (String(targetDate) == String(todayDateString)) {
                if (prevActiveHanlder) {
                    prevActiveHanlder()
                }
            }
            //어제로 잡혀있음 -> 한국장 미국장 둘다 안돌아서 리스크 아직 추가 안되어 있는 경우
            else {
                if (activeTimeHandler) {
                    activeTimeHandler()
                }
            }
        }

        else if (hours >= 9 && hours < 10 || (hours === 10 && minutes <= 30)) {

            // 어제로 잡혀있음 -> 한국장 미국장 둘다 안돌아서 리스크/등락률 아직 추가 안되어 있는 경우
            // yesterdayIsKoeanHoliday===true && yesterdayIsUsHoliday===true 인 경우
            if (yesterdayIsHoliday) {
                if (String(targetDate) == String(todayDateString)) {
                    if (activeTimeHandler) {
                        activeTimeHandler()
                    }
                }
                else if (cryptoCalcurating) {
                    cryptoCalcurating()
                }
                else if (inactiveTimeHanlder) {
                    inactiveTimeHanlder()
                }
            }
            else {
                // 한국 or 미국장 돌아서 이미 리스크+등락률 추가되어 있는 경우
                if (activeTimeHandler) {
                    activeTimeHandler()
                }
            }

        }
        else if ((hours > 10 && hours < 16) || (hours === 10 && minutes > 30)) {

            if (String(targetDate) == String(todayDateString)) {
                if (activeTimeHandler) {
                    activeTimeHandler()
                }
            }
            //한국 장마감~한국 포폴 배치 사이에 수정&신규생성 있는 경우(targetDate 미래로 변경) 대응
            else {
                if (prevActiveHanlder) {
                    prevActiveHanlder()
                }
            }
        }
        //16시 이후
        else {
            if (isKoreaStockInclude) {
                //한국장 안쌓임
                if (String(targetDate) == String(todayDateString)) {
                    if (activeTimeHandler) {
                        activeTimeHandler()
                    }
                }
                //한국장 쌓임
                else {
                    if (prevActiveHanlder) {
                        prevActiveHanlder()
                    }
                }
            }
            else {
                // console.log("한국장 포");

                if (activeTimeHandler) {
                    activeTimeHandler()
                }
            }
        }


    }

}